export const LAST_INPUT_ID = '5';
export const FIRST_INPUT_ID = '0';
export const CODE_LENGTH = 6;
export const MIN_LENGTH = 1;
